type Params = {
  tab: string
  tScoped: (key: string) => string
  isEditActive: boolean
}

export const getTitle = ({ tab, tScoped, isEditActive }: Params): string => {
  if (tab !== 'imageSettings') {
    return tScoped(`${tab}.title`)
  }

  const modeTranslationKey = isEditActive ? 'onEdit' : 'onCreate'

  return tScoped(`${tab}.title.${modeTranslationKey}`)
}
